/* tslint:disable */
/* eslint-disable */
/**
 * Warpgate Web Admin
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.20.2-27-g52fb3b68-modified
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ExistingSsoCredential interface.
 */
export function instanceOfExistingSsoCredential(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('email' in value) || value['email'] === undefined)
        return false;
    return true;
}
export function ExistingSsoCredentialFromJSON(json) {
    return ExistingSsoCredentialFromJSONTyped(json, false);
}
export function ExistingSsoCredentialFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'provider': json['provider'] == null ? undefined : json['provider'],
        'email': json['email'],
    };
}
export function ExistingSsoCredentialToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'provider': value['provider'],
        'email': value['email'],
    };
}
